import { differenceWith as _differenceWith, isEqual as _isEqual } from 'lodash-es';

/**
 * Given two arrays, returns which values have been added to the current
 * value and which values have been removed from the previous value.
 * Eg: current: [1,2,3], prev: [2,3,4] => {add: [1], remove: [4]}
 * // import _(.+) from 'lodash\/\1
 *
 * @param current Value containing changes
 * @param previous Previous, or original value to compare against
 */
export function addRemove<T>(current: T[], previous: T[], customizer?: (objValue: T, othValue: T) => boolean): { add: T[]; remove: T[]} {
  const add: T[] = _differenceWith(current, previous, customizer || _isEqual);
  const remove: T[] = _differenceWith(previous, current,  customizer ||  _isEqual);

  return { add, remove };
}
